import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const MOBILE_BREAKPOINT = 768;
function useIsMobile() {
    const [isMobile, setIsMobile] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(()=>{
        if ('undefined' == typeof window) return false;
        return window.innerWidth < MOBILE_BREAKPOINT;
    });
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        if ('undefined' == typeof window) return;
        const handleResize = ()=>{
            setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        };
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return isMobile;
}
export { useIsMobile };

//# sourceMappingURL=useIsMobile.mjs.map